export const pages = 'mapping/account/:accountId/pages';
export const pageDetail = 'mapping/account/:accountId/pages/:id';
